<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon">
      <mat-icon>payment</mat-icon>
    </div>
    <div class="pp-header-text">
      <h2 class="cf-dlg-title">{{ editing ? 'Editar pago de la inversión' : 'Pago de la inversión' }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando pagos…"></app-loading-state>
  <app-loading-state *ngIf="saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="pp-empty pp-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los pagos de la inversión.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body pp-body">

      <div class="pp-remaining">
        <div class="pp-remaining__left">
          <div class="pp-remaining__icon-wrap"><mat-icon>account_balance_wallet</mat-icon></div>
          <div>
            <span class="pp-remaining__label">Importe pendiente</span>
            <span class="pp-remaining__amount">{{ remaining | number:'1.2-2' }} €</span>
            <span class="pp-remaining__hint">
              Inversión {{ total | number:'1.2-2' }} € · Pagado {{ paidAmount | number:'1.2-2' }} €
            </span>
          </div>
        </div>
        <div class="pp-remaining__actions" *ngIf="showForm">
          <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="assignRemaining()">
            <mat-icon>check</mat-icon> Asignar pendiente
          </button>
        </div>
      </div>

      <div class="pp-section" *ngIf="isPaid && !editing">
        <div class="pp-paid-badge">
          <mat-icon>check_circle</mat-icon>
          Inversión pagada por completo
        </div>
      </div>

      <ng-container *ngIf="showForm">
        <div class="pp-section">
          <span class="cf-dlg-section__label">
            {{ editing ? 'Editar pago' : 'Forma de pago' }}
            <button *ngIf="editing" type="button" class="pp-link" (click)="cancelEdit()">Cancelar edición</button>
          </span>

          <div class="pp-alert" *ngIf="saveError">
            <mat-icon>error</mat-icon>
            <span>{{ saveError }}</span>
          </div>

          <div class="pp-grid">
            <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.typePay">
              <app-autocomplete [control]="typePayControl" [config]="methodConfig"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.typePay"><mat-icon>error</mat-icon> {{ errors.typePay }}</div>
            </div>

            <div *ngIf="typePay === methods.cash" class="cf-field--required" [class.cf-field--invalid]="submitted && errors.cash">
              <app-autocomplete [control]="control('cash')" [config]="configs.cash"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.cash"><mat-icon>error</mat-icon> {{ errors.cash }}</div>
            </div>

            <div *ngIf="typePay === methods.creditCard" class="cf-field--required" [class.cf-field--invalid]="submitted && errors.creditCard">
              <app-autocomplete [control]="control('creditCards')" [config]="configs.creditCards"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.creditCard"><mat-icon>error</mat-icon> {{ errors.creditCard }}</div>
            </div>

            <div *ngIf="typePay === methods.transfer" class="cf-field--required" [class.cf-field--invalid]="submitted && errors.bankAccount">
              <app-autocomplete [control]="control('bankAccounts')" [config]="configs.bankAccounts"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.bankAccount"><mat-icon>error</mat-icon> {{ errors.bankAccount }}</div>
            </div>

            <div *ngIf="typePay === methods.partner" class="cf-field--required" [class.cf-field--invalid]="submitted && errors.partner">
              <app-autocomplete [control]="control('partners')" [config]="configs.partners"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.partner"><mat-icon>error</mat-icon> {{ errors.partner }}</div>
            </div>

            <div *ngIf="typePay === methods.creditPolicy" class="cf-field--required" [class.cf-field--invalid]="submitted && errors.creditPolicy">
              <app-autocomplete [control]="control('creditPolicies')" [config]="configs.creditPolicies"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.creditPolicy"><mat-icon>error</mat-icon> {{ errors.creditPolicy }}</div>
            </div>
          </div>
        </div>

        <div class="pp-section">
          <span class="cf-dlg-section__label">Datos del pago</span>
          <div class="pp-grid">
            <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.depositDate">
              <app-date [control]="depositDateControl" [config]="{ label: 'Fecha de pago', required: true }"></app-date>
              <div class="cf-field__error" *ngIf="submitted && errors.depositDate"><mat-icon>error</mat-icon> {{ errors.depositDate }}</div>
            </div>

            <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.amount">
              <app-field [control]="amountControl" [config]="{ label: 'Importe', type: 'number', required: true, suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
              <div class="cf-field__error" *ngIf="submitted && errors.amount"><mat-icon>error</mat-icon> {{ errors.amount }}</div>
            </div>

            <div *ngIf="typePay === methods.transfer" [class.cf-field--invalid]="submitted && errors.commissions">
              <app-field [control]="commissionsControl" [config]="{ label: 'Comisión bancaria', type: 'number', suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
              <div class="cf-field__error" *ngIf="submitted && errors.commissions"><mat-icon>error</mat-icon> {{ errors.commissions }}</div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="pp-section" *ngIf="deposits.length">
        <span class="cf-dlg-section__label">Pagos registrados</span>
        <div class="pp-deposits">
          <div class="pp-deposit-row" *ngFor="let row of deposits; trackBy: trackByUid" [class.pp-deposit-row--editing]="editing?.uid === row.uid">
            <div class="pp-deposit-row__main">
              <div class="pp-deposit-row__amount">{{ row.amount | number:'1.2-2' }} €</div>
              <div class="pp-deposit-row__meta">
                {{ row.typePay || 'Sin forma de pago' }}{{ row.bankAccountInfo ? ' · ' + row.bankAccountInfo : '' }}{{ row.commissions ? ' · Comisión ' + (row.commissions | number:'1.2-2') + ' €' : '' }}{{ row.conciliationId ? ' · Conciliado' : '' }}
              </div>
            </div>
            <div class="pp-deposit-row__date">{{ row.depositDate | date:'dd/MM/yyyy' }}</div>
            <div class="pp-deposit-row__actions">
              <button mat-icon-button class="pp-deposit-row__btn" (click)="startEdit(row)" title="Editar" aria-label="Editar pago">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="pp-deposit-row__btn pp-deposit-row__btn--danger" (click)="deleteDeposit(row)" title="Eliminar" aria-label="Eliminar pago">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button *ngIf="showForm" mat-flat-button class="cf-dlg-btn-primary" (click)="save()">
        <mat-icon>{{ editing ? 'save' : 'check_circle' }}</mat-icon> {{ editing ? 'Guardar cambios' : 'Pagar' }}
      </button>
    </div>
  </ng-container>
</div>
